export default "https://cdn-static.gokick.com/assets/643951300d065933ed58add7baf5b7b086396c88/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";